"use client";

import styled from "styled-components";

export const Noop = styled.div`
  display: none;
`;
